import { render, staticRenderFns } from "./SecondsCountdown.vue?vue&type=template&id=2060e6be&"
import script from "./SecondsCountdown.vue?vue&type=script&lang=js&"
export * from "./SecondsCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports